export default {
  state: {
    roles: [],
    users: [],
    partners: [],
    filters: {},
    pagination: {},
  },
  mutations: {
    setRoles(state, payload) {
      state.roles = payload
    },
    setUsers(state, payload) {
      state.users = payload
    },
    setPartners(state, payload) {
      state.partners = payload
    },
    setUsersFilters(state, payload) {
      state.filters = payload
    },
    setPagination(state, payload) {
      state.pagination = payload
    },
  },
  actions: {
    queryRoles({dispatch, commit}) {
      dispatch('setPreloader', true)
      axios.get(process.env.VUE_APP_API_ENDPOINT + 'roles')
        .then(res => {
          commit('setRoles', res.data)
          dispatch('setPreloader', false)
        })
        .catch(error => {
          dispatch('setToastHttpError', error.response, {root: true})
        })
    },
    queryUsers({state, dispatch, commit}) {
      dispatch('setPreloader', true)
      axios.get(process.env.VUE_APP_API_ENDPOINT + 'users', {params: state.filters})
        .then(res => {
          commit('setUsers', res.data.users)
          commit('setPagination', res.data.pagination)
          dispatch('setPreloader', false)
        })
        .catch(error => {
          dispatch('setToastHttpError', error.response, {root: true})
        })
    },
    queryPartners({dispatch, commit}) {
      dispatch('setPreloader', true)
      axios.get(process.env.VUE_APP_API_ENDPOINT + 'partners')
        .then(res => {
          commit('setPartners', res.data.users)
          dispatch('setPreloader', false)
        })
        .catch(error => {
          dispatch('setToastHttpError', error.response, {root: true})
        })
    },
    storeUser({dispatch, commit}, formData) {
      dispatch('setPreloader', true)
      axios.post(process.env.VUE_APP_API_ENDPOINT + 'users', formData)
        .then(res => {
          dispatch('queryUsers')
          dispatch('setToast', {status: 'success', message: res.data.message})
          dispatch('closeModal', true)
          dispatch('setPreloader', false)
        })
        .catch(error => {
          dispatch('setToastHttpError', error.response, {root: true})
          dispatch('setPreloader', false)
        })
    },
    updateUser({dispatch, commit}, payload) {
      dispatch('setPreloader', true)
      axios.patch(process.env.VUE_APP_API_ENDPOINT + 'users/' + payload[0], payload[1])
        .then(res => {
          dispatch('queryUsers')
          dispatch('setToast', {status: 'success', message: res.data.message})
          dispatch('closeModal', true)
          dispatch('setPreloader', false)
        })
        .catch(error => {
          dispatch('setToastHttpError', error.response, {root: true})
        })
    },
    massUpdateUsers({dispatch, commit}, payload) {
      dispatch('setPreloader', true)
      axios.patch(process.env.VUE_APP_API_ENDPOINT + 'users/mass', payload)
        .then(res => {
          dispatch('queryUsers')
          dispatch('setToast', {status: 'success', message: res.data})
          dispatch('closeModal', true)
          dispatch('setPreloader', false)
        })
        .catch(error => {
          dispatch('setToastHttpError', error.response, {root: true})
        })
    },
    destroyUser({dispatch, commit}, user_id) {
      dispatch('setPreloader', true)
      axios.delete(process.env.VUE_APP_API_ENDPOINT + 'users/' + user_id)
        .then(res => {
          dispatch('queryUsers')
          dispatch('setToast', {status: 'success', message: res.data})
          dispatch('setPreloader', false)
        })
        .catch(error => {
          dispatch('setToastHttpError', error.response, {root: true})
        })
    },
    massDestroyUsers({dispatch, commit}, users_ids) {
      dispatch('setPreloader', true)
      axios.delete(process.env.VUE_APP_API_ENDPOINT + 'users/mass', {data: {ids: users_ids}})
        .then(res => {
          dispatch('queryUsers')
          dispatch('setToast', {status: 'success', message: res.data})
          dispatch('setPreloader', false)
        })
        .catch(error => {
          dispatch('setToastHttpError', error.response, {root: true})
        })
    },
    exportUsers({dispatch, commit}, users_ids) {
      dispatch('setPreloader', true)
      axios.post(process.env.VUE_APP_API_ENDPOINT + 'export/users', users_ids, {responseType: 'blob'})
        .then(res => {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'users_export.xlsx');
          document.body.appendChild(link);
          link.click();

          dispatch('setPreloader', false)
        })
        .catch(error => {
          dispatch('setToastHttpError', error.response, {root: true})
        })
    },
  },
  getters: {
    getRoles(state) {
      return state.roles
    },
    getRolesOptions(state) {
      return function (all, filter) {
        let roles = []
        if (all)
          roles.push('All')
        for (let item of state.roles)
          if (!filter || (filter && filter.includes(item.name)))
            roles.push(item.text)
        return roles
      }
    },
    getPartners (state) {
      return state.partners
    },
    getUsers(state) {
      return state.users
    },
    getUsersPagination(state) {
      return state.pagination
    },
    getPartnersOptions(state) {
      return function (all) {
        let partners = []
        if (all) partners.push({id: 0, text: 'All'})
        if (this.getAuthUser.role_name === 'Observer'){
          this.getAuthUser.partners.forEach(item => {
            console.log(item)
            partners.push({id: item.id, text: item.name})
          })
        } else {
          for (let i in state.partners) {
            partners.push({id: state.partners[i].id, text: state.partners[i].name})
          }
        }
        return partners
      }
    },
    getPartnersOptionsForModal(state) {
        let partners = []
        for (let key in state.partners) {
          partners.push({id: state.partners[key].id, text: state.partners[key].name})
        }
        return partners

    },
    getMonitorsOptions(state) {
      return function (all) {
        let monitors = []
        if (all)
          monitors.push({id: 0, text: 'All'})
        for (let i in state.users) {
          if (state.users[i].roles[0].name == 'Monitor')
            monitors.push({id: state.users[i].id, text: state.users[i].name})
        }
        return monitors
      }
    },
    getMonitorsWithResultsOptions(state) {
      return function (all) {
        let monitors = []
        if (all)
          monitors.push({id: 0, text: 'All'})
        for (let i in state.users) {
          if (state.users[i].roles[0].name == 'Monitor' && state.users[i].results_count)
            monitors.push({id: state.users[i].id, text: state.users[i].name})
        }
        return monitors
      }
    }
  }
}
